module.exports = __webpack_public_path__ + "static/media/minus-button-with-color.9bd414d5.svg";